import React, { Component } from 'react';
import styles from './StepsSideBar.scss';
import { getMergedClassNames } from '../../../utils/HTMLUtils';
import PropTypes from 'prop-types';
import StepSidebar from './StepSidebar';

const rootClassName = styles.rootClassName;

class StepsSidebar extends Component {
  render() {
    return (
      <div className={getMergedClassNames([rootClassName])}>
        <div className={rootClassName + '-container'}>
          <div className={rootClassName + '-content'}>
            {this.props.steps.map((step, index) => {
              return <StepSidebar {...step} key={index} />;
            })}
          </div>
        </div>
      </div>
    );
  }
}

StepsSidebar.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.exact(StepSidebar.propTypes).isRequired)
    .isRequired,
};

export default StepsSidebar;
